import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-i18next';
import Navigation from '../components/Navigation';
import QuestionTypeTable from '../components/QuestionTypeTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    InputGroup,
    FormGroup
} from 'react-bootstrap';

import './QuestionTypes.css';

class QuestionTypes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            questiontypes: [],
            page: props.page,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            pageCount: 0
        };
    }

    componentDidMount() {
        this.loadQuestionTypesFromServer();
    }

    deleteQuestionType(questiontype) {
        var self = this;
        axios
            .delete(`${config.baseURL}/questiontypes/${questiontype.id}`)
            .then(function(response) {
                self.loadQuestionTypesFromServer()();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadQuestionTypesFromServer() {
        var self = this;
        axios
            .get(`${config.baseURL}/questiontypes`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    questiontypes: response.data.questionTypes,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {        
            this.loadQuestionTypesFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url); 

        event.preventDefault();
        this.loadQuestionTypesFromServer();
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'QuestionTypes.title'
        )}`;

        return (
            <div className="QuestionTypes">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('QuestionTypes.title')}

                                    <Link
                                        type="submit"
                                        className="btn btn-primary"
                                        to="/qanda/questiontypes/create"
                                    >
                                        <em className="fa fa-plus fa-fw" />{' '}
                                        {t('QuestionTypes.add_questiontype')}
                                    </Link>
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-info" />{' '}
                                        <Link to={`/qanda`}>
                                            {t('QAndA.title')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fa fa-list" />{' '}
                                        {t('QuestionTypes.title')}
                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={3}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <QuestionTypeTable
                                        questiontypes={this.state.questiontypes}
                                        onDelete={this.deleteQuestionType.bind(
                                            this
                                        )}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(QuestionTypes);
